<app-filter-panel [quickSearchFilter]="filters.name" quickSearchPlaceholder="Nombre" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
    <span class="w-full input-field p-input-icon-right">
        <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer"
            (click)="filters.name.value = null; search()"></i>
    </span>
</div>
-->

<p-table #grid [value]="datasets" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
            <th width="30">Activo</th>
            <th width="180">Ultimo snapshot</th>
            <th width="140"></th>
        </tr>   
    </ng-template>
    <ng-template pTemplate="body" let-dataset let-columns="columns">
        <tr (dblclick)="edit(dataset)">
            <td>{{dataset.name}}</td>
            <td>
                <i class="text-green-500 pi" [class.pi-check-circle]="dataset.active"></i>
                <i class="text-red-500 pi" [class.pi-times]="!dataset.active"></i>
            </td>
            <td [class.text-red-500]="dataset.lastSnapshotSuccess === false">
                {{dataset.lastSnapshotDate | date:'dd/MM/yyyy HH:mm'}}
                <i *ngIf="dataset.lastSnapshotSuccess === false" class="pi pi-exclamation-triangle text-red-500 ml-2"
                    [pTooltip]="dataset.lastSnapshotError" tooltipPosition="left"></i>
                <div *ngIf="dataset.lastSnapshotDuration" class="text-xs text-color-secondary">
                    Duración: {{formatDuration(dataset.lastSnapshotDuration)}}
                </div>
            </td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowWrite" (click)="snapshot(dataset)" [rounded]="true" [text]="false"
                        severity="secondary" pTooltip="Ejecutar snapshot"><i class="pi pi-sync"></i></p-button>
                    <p-button *ngIf="allowDelete" (click)="delete(dataset)" [rounded]="true" [text]="false"
                        severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="edit(dataset)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>